import type { Assignment, UploadSearch } from '../types/question.types';

type AssignmentFilters = Pick<
  UploadSearch,
  | 'instituteId'
  | 'instituteName'
  | 'instituteCode'
  | 'instituteEiin'
  | 'divisionName'
  | 'districtName'
  | 'thanaName'
>;

function contains(value: string | null, term: string | undefined): boolean {
  if (term === undefined) return true;
  return (value ?? '').toLowerCase().includes(term.toLowerCase());
}

function matches(value: string | null, wanted: string | undefined): boolean {
  if (wanted === undefined) return true;
  return value === wanted;
}

export function filterAssignments(
  assignments: Assignment[],
  filters: AssignmentFilters,
): Assignment[] {
  return assignments.filter(
    (assignment) =>
      (filters.instituteId === undefined || assignment.instituteId === filters.instituteId) &&
      contains(assignment.instituteName, filters.instituteName) &&
      contains(
        assignment.instituteCode === null ? null : String(assignment.instituteCode),
        filters.instituteCode,
      ) &&
      contains(assignment.instituteEiin, filters.instituteEiin) &&
      matches(assignment.divisionName, filters.divisionName) &&
      matches(assignment.districtName, filters.districtName) &&
      matches(assignment.thanaName, filters.thanaName),
  );
}
